import Module from "../module";
import baseRoute from "./routes/index";
import en from "./translations/en.json";

export default new Module(baseRoute, { en, nl: {} }, [
	"can_manage_dimension_values",
]);
